module.exports = __webpack_public_path__ + "img/op_fondo-cta-empresas-mobile.7c65165.jpg";